export const EXPORT_HISTORY_PT_BR = {
	title: "Planilhas Exportadas",
	subtitle: "Histórico das últimas exportações realizadas",
	noExports: "Nenhuma exportação encontrada",
	noExportsDescription:
		"Seus relatórios exportados ficarão disponíveis aqui por 7 dias para baixar ou reenviar por e-mail.",
	columns: {
		date: "Data/Hora",
		user: "Usuário",
		status: "Status",
		email: "Email",
		actions: "Ações",
		fileName: "Arquivo",
	},
	status: {
		success: "Sucesso",
		pending: "Processando",
		error: "Erro",
	},
	actions: {
		download: "Baixar",
		resend: "Reenviar",
		viewDetails: "Ver detalhes",
		retry: "Tentar novamente",
	},
	tooltips: {
		processing:
			"Estamos processando a sua solicitação.\nEm breve, o relatório estará disponível para baixá-lo",
		error: "Erro ao processar a sua solicitação.",
		download: "Baixar relatório",
		resend: "Reenviar relatório",
	},
	messages: {
		resendSuccess: "Planilha reenviada com sucesso!",
		resendError: "Erro ao reenviar planilha",
		downloadError: "Erro ao baixar planilha",
		loading: "Carregando...",
		loadError: "Erro ao carregar histórico de exportações",
	},
	drawer: {
		title: "Planilhas exportadas",
		description:
			"Aqui estão as exportações dos últimos 7 dias. Você pode baixar ou reenviar para o mesmo e-mail cadastrado.",
		close: "Fechar",
	},
	exportButton: {
		export: "Exportar",
		exportEmail: "Exportar para e-mail",
		viewHistory: "Planilhas Exportadas",
	},
	reportTitle: "Relatório de {{startDate}} a {{endDate}}",
	exportedAt: "Exportado {{date}} às {{time}}",
	to: "Para:",
};

export type ExportHistoryTranslations = typeof EXPORT_HISTORY_PT_BR;
